import styled from 'styled-components';
import query from '../../../const/mediaQueries';
import { colors, consumerTheme, fontSizes, fontWeights, spacing } from '../../../defaultTheme';
export const StepBase = styled.ol `
  display: flex;
  flex-direction: row;
  position: relative;
  padding: 0;
  margin: 0 auto;
  @media ${query.lessThanSmall} {
    margin: 0;
  }
`;
export const StepList = styled.li `
  display: flex;
  flex: 1;
  flex-direction: column;
  list-style-type: none;
  font-family: 'Open Sans';
  font-size: ${fontSizes.small}px;
  align-items: center;
  position: relative;
  margin: 0;

  &:before {
    position: absolute;
    content: '';
    width: 100%;
    top: 8px;
    left: 50%;
    border-bottom: ${({ status }) => `4px solid ${status === 'completed'
    ? consumerTheme.progressStepBar.fill
    : colors.turquoiseLight}`};
  }

  &:last-child::before {
    content: none;
  }
`;
export const StepNode = styled.span `
  position: relative;
  box-sizing: border-box;
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: ${colors.white};

  background-color: ${({ status }) => status === 'completed' ? consumerTheme.progressStepBar.fill : colors.white};

  box-shadow: ${({ status }) => {
    switch (status) {
        case 'active':
            return `0 0 0 6px ${consumerTheme.progressStepBar.fill}`;
        case 'completed':
            return `0 0 0 4px ${consumerTheme.progressStepBar.fill}`;
        default:
            return `0 0 0 4px ${colors.turquoiseLight}`;
    }
}};

  /* note: this border adds additional border fill to the inside of the active step node to simulate a 32px circle with 10px stroke  */
  border: ${({ status }) => status === 'active'
    ? `4px solid ${consumerTheme.progressStepBar.fill}`
    : 'unset'};

  color: ${({ status }) => (status === 'completed' ? colors.white : 'unset')};

  ${({ onClick, status, theme }) => onClick &&
    `
      &:hover:before {
        box-shadow: 0 0 1px 4px
          ${status === 'completed' || status === 'active'
        ? theme.progressStepBar.hover
        : 'transparent'};
      }
      &:hover {
        cursor: pointer;
        color: ${colors.black};
      }
    `};
`;
export const StepLabel = styled.span `
  text-align: center;
  overflow-wrap: anywhere;
  padding: 0 4px;
  margin-top: ${spacing.medium}px;
  font-weight: ${({ status, $isLastStep }) => status === 'active' || (status === 'completed' && $isLastStep)
    ? fontWeights.bold
    : fontWeights.regular};
`;
export const NonVisualInfo = styled.span `
  position: absolute;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
`;
